import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointService } from '@app/core';
import {
  Microproceso,
  TramiteBasico,
  Tarea,
  DefaultDocument,
  Forma
} from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ReportsStructureDataDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Consulta un tramite por default.
   *
   * @param {number} idTramite
   * @returns {Promise<TramiteBasico>}
   * @memberof ReportsStructureDataDataService
   */
  getDefaultTramite(idTramite: number): Promise<TramiteBasico> {
    return new Promise((resolve, reject) => {
      this.http.get<TramiteBasico>(this.api.get('tramiteTasks', [idTramite])).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Consulta un microproceso por default.
   *
   * @param {number} idTask
   * @returns {Promise<Microproceso>}
   * @memberof ReportsStructureDataDataService
   */
  getDefaultMicroProces(idTask: number): Promise<Microproceso> {
    return new Promise((resolve, reject) => {
      this.http.get<Microproceso>(this.api.get('microprocessTasks', [idTask])).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Consulta una tarea predeterminada en especifico con el id de la tarea
   *
   * @param {number} idTask
   * @returns {Promise<Tarea>}
   * @memberof ReportsStructureDataDataService
   */
  getTask(idTask: number): Promise<Tarea> {
    return new Promise((resolve, reject) => {
      this.http.get<Tarea>(this.api.get('defaultTask', [idTask]))
        .subscribe(
          task => {
            resolve(task);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Consulta los documentos del sistema
   *
   * @returns {Observable<DefaultDocument[]>}
   * @memberof ReportsStructureDataDataService
   */
  getDefaultDocuments(): Observable<DefaultDocument[]> {
    return new Observable(obs => {
      this.http.get<DefaultDocument[]>(this.api.get('defaultDocument')).subscribe(
        res => {
          obs.next(res);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta la forma
   *
   * @param {number} idForm
   * @returns {Observable<Forma>}
   * @memberof ReportsStructureDataDataService
   */
  getFormTask(idForm: number): Promise<Forma> {
    return new Promise((resolve, reject) => {
      this.http.get<Forma>(this.api.get('dynamicForm', [ idForm ])).subscribe(
        form => {
          form.sub_formas.sort((a, b) => a.orden - b.orden);
          form.sub_formas.forEach(subForm => {
            subForm.campos.sort((a, b) => a.orden - b.orden);
          });
          resolve(form);
        },
        err => {
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/reports-structure/reports-structure-data/shared/reports-structure-data.data.service.ts